import { NumericInput } from '@interstate/components/NumericInput';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import { useCustomerCardContext } from '../CustomerCardProvider';
import type { ErrorState } from '@makemydeal/dr-dash-ui-utils';
import { kebabCase } from 'lodash';

type DurationFieldProps = {
    label: string;
    value: string;
    field: string;
    error: ErrorState;
};

export const DurationField = ({ label, value, field, error }: DurationFieldProps) => {
    const { handleNumberInputChange, isLocked } = useCustomerCardContext();

    return (
        <NumericInput
            name={field}
            displayLabel={true}
            label={label}
            value={value}
            allowDecimal={false}
            onChange={(e: InterstateOnChangeEvent<string>) => handleNumberInputChange(field, e.target.value)}
            disabled={isLocked}
            hasError={Boolean(error.hasError)}
            errorMessage={error.errorMessage || ''}
            data-testid={`customer-form-${kebabCase(field)}`}
            size="sm"
        />
    );
};
